import {element} from "./var";

const _globals = {};
const _phrases = {};

/**
 * Returns Globals object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object|*} Globals object if no key is provided, otherwise associated value
 */
export function globals(key = null, defaultValue = null) {
	const g = window.globals || _globals;
	return key !== null ? element(g, key, defaultValue) : g;
}

/**
 * Returns global Phrases object
 * @param {string|null} key Optional key to return
 * @param {*} defaultValue Default value for key
 * @return {object} Phrases object if no key is provided, otherwise associated value
 */
export function phrases(key = null, defaultValue = null) {
	const g = globals('phrases') || _phrases;
	return key !== null ? element(g, key, defaultValue) : g;
}



// WEBPACK FOOTER //
// ./core/utils/globals.js